import SeoHead from "../components/seo/SeoHead";
import Login from "./Login";
import "./Academy.css";

function LegacyAcademy() {
    return (
        <div className="academy-page academy-legacy-page">
            <SeoHead
                title="Legacy Academy | TheQAHub"
                description="Espacio dedicado a la Academy anterior de TheQAHub, la que vivía dentro de theqahub.es con login y secciones internas."
                canonicalPath="/academy-legacy"
            />

            <section className="academy-bridge-page">
                <div className="academy-legacy-login-shell">
                    <Login />
                </div>
            </section>
        </div>
    );
}

export default LegacyAcademy;
